// Auto-generated file by optimize_images.py. Do not edit directly.
import img1 from "../images/playzone_opt/playzone_1.webp";
import img2 from "../images/playzone_opt/playzone_2.webp";
import img3 from "../images/playzone_opt/playzone_3.webp";
import img4 from "../images/playzone_opt/playzone_4.webp";
import img5 from "../images/playzone_opt/playzone_5.webp";
import img6 from "../images/playzone_opt/playzone_6.webp";
import img7 from "../images/playzone_opt/playzone_7.webp";
import img8 from "../images/playzone_opt/playzone_8.webp";
import img9 from "../images/playzone_opt/playzone_9.webp";
import img10 from "../images/playzone_opt/playzone_10.webp";
import img11 from "../images/playzone_opt/playzone_11.webp";
import img12 from "../images/playzone_opt/playzone_12.webp";
import img13 from "../images/playzone_opt/playzone_13.webp";

import thumb1 from "../images/playzone_opt/playzone_1_thumb.webp";
import thumb2 from "../images/playzone_opt/playzone_2_thumb.webp";
import thumb3 from "../images/playzone_opt/playzone_3_thumb.webp";
import thumb4 from "../images/playzone_opt/playzone_4_thumb.webp";
import thumb5 from "../images/playzone_opt/playzone_5_thumb.webp";
import thumb6 from "../images/playzone_opt/playzone_6_thumb.webp";
import thumb7 from "../images/playzone_opt/playzone_7_thumb.webp";
import thumb8 from "../images/playzone_opt/playzone_8_thumb.webp";
import thumb9 from "../images/playzone_opt/playzone_9_thumb.webp";
import thumb10 from "../images/playzone_opt/playzone_10_thumb.webp";
import thumb11 from "../images/playzone_opt/playzone_11_thumb.webp";
import thumb12 from "../images/playzone_opt/playzone_12_thumb.webp";
import thumb13 from "../images/playzone_opt/playzone_13_thumb.webp";

export const playzoneImages = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
];

export const playzoneThumbnails = [
  thumb1,
  thumb2,
  thumb3,
  thumb4,
  thumb5,
  thumb6,
  thumb7,
  thumb8,
  thumb9,
  thumb10,
  thumb11,
  thumb12,
  thumb13,
];

export default playzoneImages;